import React, { useCallback, useEffect, useRef, useState } from 'react'
import './inquiryList.scss'
import Button from '../../components/button/Button'
import useScreenSize from '../../hooks/useScreenSize'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import PopupBox from '../../components/popup/PopupBox'
import pencilicon from '../../assets/icons/pencil1.svg'
import HorizontalLine from '../../assets/icons/Line33.svg'
import MovetoWalkIn from '../../assets/icons/MoveToWalkIn.svg'
import TackFollowUp from '../../assets/icons/TakeFollowUp.svg'
import phoneIcon from '../../assets/icons/phoneIcon.svg'
import MailIcon from '../../assets/icons/MailIcon.svg'
import EnrollIcon from '../../assets/icons/enroll-icon.svg'
import ArchiveIcon from '../../assets/icons/archive.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import ModalUnstyled from '../../components/model/Model'
import { capitalizeFirstLetter, convertDate } from '../../utility/genricFunction'
import TableDateInput from '../../components/table-date-input/TableDateInput'
import FromToDatePicker from '../../components/from-to-datePicker/FromToDatePicker'
import { getInquiries, inquiryArchive } from '../../store/builders/inquiry/inquiry.builder'
import { setDateFrom, setDateTo, setInquiryType, setInquiryByWalkin } from '../../store/slice/inquiry/inquiry.slice'
import ServerParentDataTable from '../../components/data-table/ServerParentDataTable'
import { setInquiryEnrollData } from '../../store/slice/enrollment/enrollment.slice'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'

function InquiryList() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { allInquiryData, loading, dateFrom, dateTo, inquiryPageData } = useSelector((state) => state.inquiry)
  const roleSelector = useSelector((store) => store.auth)
  const userRole = roleSelector?.user?.result?.userData?.roleName

  const screenSize = useScreenSize()
  const [isCourseForm, setIsCourseForm] = useState(false)
  const [selectedValue, setSelectedValue] = useState(null)
  const [page, setPage] = useState(1)

  const numbers = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ]
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [filters, setFilters] = useState({})

  const [openArchive, setOpenArchive] = React.useState(false)
  const [selectedType, setSelectedType] = React.useState(null)
  const popupRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)
  const [archiveId, setArchiveId] = useState('')

  // Helper function to parse query string
  const parseQueryParams = (search) => {
    const params = new URLSearchParams(search)
    const query = {}
    for (const [key, value] of params.entries()) {
      query[key] = value
    }
    return query
  }

  const queryParams = parseQueryParams(location.search)

  // Map query params to filter data

  useEffect(() => {
    // dispatch(getInquiries(filters))
    dispatch(setDateFrom(''))
    dispatch(setDateTo(''))

    if(location.search){
      const filterData = {
        inquiryType: queryParams.inquiryType
          ? { value: queryParams.inquiryType, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        next_followup_date_to: queryParams.next_followup_date_to
          ? { value: queryParams.next_followup_date_to, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        next_followup_date_from: queryParams.next_followup_date_from
          ? { value: queryParams.next_followup_date_from, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },

        name: queryParams.name
          ? { value: queryParams.name, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        branchName: queryParams.branchName
          ? { value: queryParams.branchName, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        courseName: queryParams.courseName
          ? { value: queryParams.courseName, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        inquiryDate: queryParams.inquiryDate
          ? { value: queryParams.inquiryDate, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        inquiryStatus: queryParams.inquiryStatus
          ? { value: queryParams.inquiryStatus, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        verified: queryParams.verified
          ? { value: queryParams.verified, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },

        // Add other filters as needed...
      }
      // Dispatch the action with the filter data
      if (queryParams && location.search) {
        filterData.limit = {
          value: selectedNumber,
          matchMode: 'startsWith',
        }

        filterData.page = {
          value: page,
          matchMode: 'startsWith',
        }


        //setFilters(filterData)
        setSelectedType(queryParams.inquiryType)
      }
    }
  }, [])

  const deepMerge = (target, source) => {
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object' && target[key]) {
        // Recursively merge if both values are objects
        target[key] = deepMerge(target[key], source[key]);
      } else {
        // Otherwise, just assign the value
        target[key] = source[key] ?? target[key];
      }
    }
    return target;
  };


  useEffect(() => {
    const newFilters = { ...filters };

    // Ensure limit and page are always updated
    newFilters.limit = {
      value: selectedNumber,
      matchMode: 'startsWith',
    };

    newFilters.page = {
      value: page,
      matchMode: 'startsWith',
    };

    // Handle nextFollowupDate and inquiryDate changes properly
    if (filters?.nextFollowupDate) {
      let followupDate = filters.nextFollowupDate?.value;
      let followupDateFrom = followupDate ? convertDate(followupDate) : '';
      let followupDateObj = new Date(followupDate?.split('/').reverse().join('/'));
      followupDateObj.setDate(followupDateObj.getDate());

      let followupDateTo = followupDateObj.toLocaleDateString('en-GB').split('/').reverse().join('-');
      let date = new Date(followupDateTo);

      newFilters.next_followup_date_from = {
        value: followupDateFrom || '',
        matchMode: 'startsWith',
      };

      newFilters.next_followup_date_to = {
        value: !isNaN(date) ? followupDateTo : '',
        matchMode: 'startsWith',
      };
      delete newFilters.nextFollowupDate; // Delete unnecessary field
    }

    let inquDateFrom = '';
    let inquDateTo = '';

    if (dateFrom && dateFrom !== '') {
      const date = new Date(dateFrom);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      inquDateFrom = `${year}-${month}-${day}`;
    }

    if (dateTo && dateTo !== '') {
      const date2 = new Date(dateTo);
      date2.setDate(date2.getDate());
      const year2 = date2.getFullYear();
      const month2 = String(date2.getMonth() + 1).padStart(2, '0');
      const day2 = String(date2.getDate()).padStart(2, '0');
      inquDateTo = `${year2}-${month2}-${day2}`;
    }

    newFilters.inquiry_date_from = {
      value: inquDateFrom,
      matchMode: 'startsWith',
    };

    newFilters.inquiry_date_to = {
      value: inquDateTo,
      matchMode: 'startsWith',
    };
    delete newFilters.inquiryDate; // Delete unnecessary field

    let filterData = {};

    // Check if location.search has query parameters
    if (location.search) {
      filterData = {
        inquiryType: queryParams.inquiryType
          ? { value: queryParams.inquiryType, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        next_followup_date_to: queryParams.next_followup_date_to
          ? { value: queryParams.next_followup_date_to, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        next_followup_date_from: queryParams.next_followup_date_from
          ? { value: queryParams.next_followup_date_from, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        name: queryParams.name
          ? { value: queryParams.name, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        branchName: queryParams.branchName
          ? { value: queryParams.branchName, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        courseName: queryParams.courseName
          ? { value: queryParams.courseName, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        inquiryDate: queryParams.inquiryDate
          ? { value: queryParams.inquiryDate, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        inquiryStatus: queryParams.inquiryStatus
          ? { value: queryParams.inquiryStatus, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
        verified: queryParams.verified
          ? { value: queryParams.verified, matchMode: 'startsWith' }
          : { value: null, matchMode: 'startsWith' },
      };

      // Ensure pagination is added to the filterData
      filterData.limit = {
        value: selectedNumber,
        matchMode: 'startsWith',
      };

      filterData.page = {
        value: page,
        matchMode: 'startsWith',
      };
      //setSelectedType(queryParams.inquiryType)
    }

    // Merge both filterData (from queryParams) and newFilters (local state updates)
    // const finalFilters = deepMerge({}, filterData, newFilters);
    const mergedFilters = { ...filterData }; // Clone filterData to avoid mutating the original object

    // Merge newFilters into mergedFilters
    for (const key in newFilters) {
      if (newFilters[key].value !== null && newFilters[key].value !== '') {
        mergedFilters[key] = newFilters[key]; // Replace or add the new filter value
      }
    }


    console.log("finalFilters", mergedFilters);

    // Dispatch the action with the merged filters
    dispatch(getInquiries(mergedFilters));
  }, [filters, selectedNumber, page, dateTo, dateFrom]);



  const handleArchive = (id) => {
    setOpenArchive(true)
    setArchiveId(id)
    setIsOpen(true)
  }

  const handleArchiveConfirm = (inquiryId) => {
    dispatch(inquiryArchive({ inquiryId })) // Example action
    setOpenArchive(false)
  }

  const statuses = [
    { label: 'alive', value: 'alive' },
    { label: 'dead', value: 'dead' },
  ]
  const types = [
    { label: 'telephonic', value: 'telephonic' },
    { label: 'walkin', value: 'walkin' },
    { label: 'T2w', value: 't2w' },
  ]

  const nameBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.name)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const typeBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.inquiryType)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const branchBody = (allInquiryData) => {
    const representative = allInquiryData?.branchName && capitalizeFirstLetter(allInquiryData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusBody = (allInquiryData) => {
    const representative = capitalizeFirstLetter(allInquiryData.inquiryStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const handlePopByRoles = (allInquiryData, handleEnrollRowClick, handleClickBranch) => {
    return userRole === UI_CONSTANT.ADMIN_ROLE || userRole === UI_CONSTANT.BRANCH_ROLE ? (
      <>
        {allInquiryData && (allInquiryData.inquiryType == 'walkin' || allInquiryData.inquiryType == 't2w')
          ? UseAuthorization(permissions.ENROLL_INQUIRY) && (
            <button
              className='div-assign-to-branch'
              disabled={
                allInquiryData?.inquiryArchiveStatus == 'archive' || allInquiryData.inquiryStatus == 'dead'
                  ? true
                  : false
              }
              onClick={() => handleEnrollRowClick(allInquiryData.inquiryId, allInquiryData)}
            >
              <img src={EnrollIcon} alt='' />
              <p
                className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Enroll Now
              </p>
            </button>
          )
          : UseAuthorization(permissions.MOVE_TO_WALKIN) && (
            <button
              className='div-assign-to-branch'
              disabled={
                allInquiryData?.inquiryArchiveStatus == 'archive' || allInquiryData.inquiryStatus == 'dead'
                  ? true
                  : false
              }
              onClick={() => handleClickBranch(allInquiryData.inquiryId)}
            >
              <img src={MovetoWalkIn} alt='' />
              <p
                className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Move to Walk-In
              </p>
            </button>
          )}
      </>
    ) : (
      <>
        {allInquiryData && allInquiryData.inquiryType !== 'walkin'
          ? UseAuthorization(permissions.MOVE_TO_WALKIN) && (
            <button
              className='div-assign-to-branch'
              disabled={
                allInquiryData?.inquiryArchiveStatus == 'archive' || allInquiryData.inquiryStatus == 'dead'
                  ? true
                  : false
              }
              onClick={handleClickBranch}
            >
              <img src={MovetoWalkIn} alt='' />
              <p
                className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
              >
                Move to Walk-In
              </p>
            </button>
          )
          : ''}
      </>
    )
  }

  const verifiedBodyTemplate = (allInquiryData) => {
    const handleOnButtonClick = (id) => {
      const path = ROUTES_PATH.FOLLOW_UP_LIST_CREATE.replace(':id', id)
      navigate(path)
    }
    const handleClickBranch = (id) => {
      const path = ROUTES_PATH.NEW_INQUIRY_MOVE_TO_WALKIN_INQUIRY.replace(':id', id)
      navigate(path)
      dispatch(setInquiryType('walkin'))
    }
    const handleRowClick = (id) => {
      dispatch(setInquiryType(''))
      const path = ROUTES_PATH.EDIT_INQUIRY.replace(':id', id)
      navigate(path)
    }
    const handleEnrollRowClick = (id, inquiryData) => {
      dispatch(setInquiryEnrollData(allInquiryData))
      const path = ROUTES_PATH.ADD_ENROLLMENT.replace(':id', id)
      navigate(path, { state: { inquiryData } })
    }

    return (
      <>
        <PopupBox rowData={allInquiryData} setIsOpen={setIsOpen} isOpen={isOpen} popupRef={popupRef}>
          <div className='popupbox'>
            {(UseAuthorization(permissions.MOVE_TO_WALKIN) && (
              <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>
            )) ||
              (UseAuthorization(permissions.TAKE_FOLLOW_UP) && <p className='verifiedBodyTemplate-Assign'>ACTION</p>)}

            {handlePopByRoles(allInquiryData, handleEnrollRowClick, handleClickBranch)}

            {UseAuthorization(permissions.TAKE_FOLLOW_UP) && (
              <button
                className='div-assign-to-branch'
                disabled={
                  allInquiryData?.inquiryArchiveStatus == 'archive' || allInquiryData.inquiryStatus == 'dead'
                    ? true
                    : false
                }
                onClick={() => handleOnButtonClick(allInquiryData.inquiryId)}
              >
                <img src={TackFollowUp} alt='' />
                <p
                  className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Take Follow-Up
                </p>
              </button>
            )}

            <img src={HorizontalLine} alt='' />
            <button className='div-assign-to-branch'>
              <img src={phoneIcon} alt='' />
              <p className='verifiedBodyTemplate-darkfont'>+91-{allInquiryData?.phone}</p>
            </button>
            <button className='div-assign-to-branch'>
              <img src={MailIcon} alt='' />
              <p className='verifiedBodyTemplate-darkfont'>{allInquiryData?.email}</p>
            </button>

            {(UseAuthorization(permissions.EDIT_INQUIRY) && (
              <img
                src={HorizontalLine}
                alt=''
                disabled={allInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
              />
            )) ||
              (UseAuthorization(permissions.ARCHIVE_INQUIRY) && (
                <img
                  src={HorizontalLine}
                  alt=''
                  disabled={allInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
                />
              ))}

            {UseAuthorization(permissions.EDIT_INQUIRY) && (
              <button
                className='div-assign-to-branch'
                disabled={allInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
                onClick={() => handleRowClick(allInquiryData.inquiryId)}
              >
                <img src={pencilicon} alt='' />
                <p
                  className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Edit
                </p>
              </button>
            )}

            {UseAuthorization(permissions.ARCHIVE_INQUIRY) && (
              <button
                className='div-assign-to-branch'
                disabled={allInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
                onClick={() => handleArchive(allInquiryData.inquiryId)}
              >
                <img
                  src={ArchiveIcon}
                  disabled={allInquiryData?.inquiryArchiveStatus == 'archive' ? true : false}
                  alt=''
                />
                <p
                  className={`${allInquiryData?.inquiryArchiveStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Archive
                </p>
              </button>
            )}
          </div>
        </PopupBox>
        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
            className={'archive-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => handleArchiveConfirm(archiveId)}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      />
    )
  }

  const typesRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedType(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedType}
        options={types}
        onChange={onDropdownChange}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
        style={{ minWidth: '10rem' }}
      />
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'name',
      header: 'Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'inquiryType',
      header: 'Type',
      style: { minWidth: '12rem' },
      filterMenuStyle: { width: '14rem' },
      filterElement: typesRowFilterTemplate,
      filter: true,
      body: typeBody,
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course Name',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by course...',
    },
    {
      sortable: true,
      field: 'inquiryDate',
      header: 'Date',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '19rem', backgroundColor: 'transparent' },
      filterPlaceholder: 'Search by date...',
      filterElement: FromToDatePicker,
    },
    {
      sortable: true,
      field: 'nextFollowupDate',
      header: 'Next Followup',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
      filterElement: TableDateInput,
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by branch...',
      body: branchBody,
    },
    {
      sortable: true,
      field: 'inquiryStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { width: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ].filter((column) => {
    if (
      column.field.toLowerCase() == 'branch' &&
      (userRole.toLowerCase() == 'branch' || userRole.toLowerCase() == 'inquiry')
    ) {
      return false
    } else {
      return true
    }
  })

  const handleOnClick = () => {
    setIsCourseForm((rev) => !rev)
    dispatch(setInquiryType('telephonic'))
    dispatch(setInquiryByWalkin(''))
    navigate('/inquiry/new-inquiry')
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.INQUIRY.LABEL_INQUIRY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INQUIRY.LABEL_INQUIRY,
      link: ROUTES_PATH.INQUIRY,
    },
  ]

  let timer
  const onFilterChange = (e) => {
    clearTimeout(timer)
    console.log("e.filters", e, filters)
    timer = setTimeout(() => {
      // delete newFilters.inquiryDate


      setFilters(e.filters)
    }, 1000)
  }

  const handleChangePageLimit = (e) => {
    setSelectedNumber(Number(e.value))
    setPage(1)
  }
  return (
    <>
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className={`course-list ${screenSize}`}>
          <div className='filter-bar-wraper'>
            {/* <div className='course-course'>{`Course >> Course List >> Add New Course`}</div> */}
            {/* <div className='course-course'></div> */}

            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {UseAuthorization(permissions.ADD_INQUIRY) && (
                <Button
                  // icon={`${isCourseForm ? '' : 'add'}`}
                  className={'add-btn'}
                  onClick={() => handleOnClick()}
                >
                  {isCourseForm ? UI_CONSTANT.BACK : UI_CONSTANT.INQUIRY.ADD_INQUIRY}
                </Button>
              )}
            </div>
          </div>
          {!isCourseForm && (
            <div className='group-parent'>
              <div className='frame-wrapper'>
                <div className='course-list-wrapper'>
                  <b className='course-list1'>{UI_CONSTANT.INQUIRY.ALL_INQUIRY}</b>
                </div>
              </div>
              <div className='flex page-drop-div'>
                <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
                <PageDropdown
                  options={numbers}
                  selectedValue={selectedNumber}
                  onChange={(e) => handleChangePageLimit(e)}
                  className='w-full md:w-14rem small-dropdown'
                />
                <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
              </div>

              <div className='table-card action-btn-include'>
                <ServerParentDataTable
                  value={allInquiryData}
                  rows={selectedNumber}
                  filters={filters}
                  // loading={loading}
                  globalFilterFields={['name', 'country.name', 'representative.name', 'status']}
                  columns={columns}
                  archiveKey='inquiryArchiveStatus'
                  onFilter={onFilterChange}
                  isServerSide={true}
                  pageChange={(e) => setPage(Number(e.page) + 1)}
                  totalRecords={inquiryPageData?.totalItems}
                />
              </div>
            </div>
          )}

          {/* {isCourseForm && <AddCourses />} */}
        </div>
      )}
    </>
  )
}

export default InquiryList
